import React from "react";
import styles from "./Grid.module.less";

export interface Props {
    children: JSX.Element | JSX.Element[] | null;
    columns: number;
}

export default function Grid(props: Props) {
    if (props.children === null) {
        return null;
    }
    return <div className={styles.Grid}>{props.children}</div>;
}
